import React                from 'react';
import { browserHistory }   from 'react-router';
import GlobalHeader         from '../../Fragments/GlobalHeader';
import PageSpinnerModal     from '../../Modals/PageSpinnerModal';

let QuoteError = require('../../Managers/QuoteError');
let Quote       = require('../../Managers/Quote');
let HttpService = require('../../Managers/HttpService');

const Config = HttpService.getConfigForHost();
const PreReferral = React.createClass({
    getInitialState() {
        return {
            reasons: null,
            quoteId: null,
            isShowPageSpinner : false,
        };
    },
    componentWillMount() {
        // filter the errors to be unique
        let e = QuoteError.get();
        let reasons = e.displayError.filter(function(error, index, array) {
            return array.indexOf(error) == index;
        });

        let quoteId = e.quoteNumber;

        this.setState({
            reasons,
            quoteId,
        });
    },
    goBack(e) {
        e.preventDefault();
        browserHistory.push('/start');
    },
    moveForward() {
        let _this = this;

        window.setLocalStorageAnswer('refer_consent', 'yes');

        this.setState({
            isShowPageSpinner : true
        });

        Quote.generateQuote(Config.api.quote.method, Config.api.quote.url).then(
            function(s) {
                if (typeof s.results === 'object') {
                    Quote.cacheQuote(s.results);
                    _this.setState({
                        isShowPageSpinner : false,
                    });
                }
            },
            function() {}
        );
        browserHistory.push('/quote-referred');
    },
    render() {
        window.scrollTo(0, 0);

        let titleToUse = (Quote.getCurrentAnswer('other_title')) ? Quote.getCurrentAnswer('other_title') : Quote.getCurrentAnswer('title');

        return (
            <div>
                <GlobalHeader />

                <div className="container stepless" />
                <question-row>
                    <div className="question-main">
                        <h1>We need some additional information</h1>
                        <p>Thank you for the information you&rsquo;ve entered so far {titleToUse} {Quote.getCurrentAnswer('last_name')}, based on what you&rsquo;ve entered we&rsquo;ll need to gather some additional details before we can complete your quote. This is because:</p>
                        <ul>
                            {this.state.reasons.map(function(error, i) {
                                return <li key={i}>{error}</li>;
                            })}
                        </ul>
                    </div>
                </question-row>

                <div className="alternate-background">
                    <question-row class="no-border">
                        <div className="question-main">
                            <h2>Submitting your quote to our insurance team</h2>
                            <p>Please select submit below and the information you&rsquo;ve supplied will be sent to our expert Insurance team. We&rsquo;ll then be in touch within 24 hours to discuss you quote, or you can call us on 0800 038 4574.</p>
                            <p><strong>Your quote reference number for the information that you&rsquo;ve entered so far is {this.state.quoteId}</strong></p>
                        </div>
                    </question-row>
                </div>

                <question-row class="no-border">
                    <div className="form-navigation">
                        <button className="btn btn-success btn-split-content" onClick={this.moveForward}>SUBMIT</button>
                        <a href="#" className="underline" onClick={this.goBack}>&lt; Back</a>
                    </div>
                </question-row>

                {this.state.isShowPageSpinner ?
                    <PageSpinnerModal
                        message="Referring quote..."
                        ref="PageSpinnerModal"
                    />
                : null}
            </div>
        );
    }
});

export default PreReferral;



/** WEBPACK FOOTER **
 ** ./src/components/Screens/Quote/PreReferral.js
 **/